<app-bottom-sheet-mobile-header (closeEvent)="bottomSheetRef.dismiss()" />
<div class="mobile-action-sheet">
  <div class="mx-6 my-3 flex justify-between items-center">
    <h2 class="sheet-title">Filters</h2>
    @if(hasSelectedFilters()) {
      <button
        class="mobile-filter-clear-all-btn"
        (click)="filtersStore.clearFilters(data.showLocationFilter)"
      >
        Clear All
      </button>
    }
  </div>
  <div class="mobile-action-sheet-content">
    <mat-accordion class="bottom-sheet-accordion">
      @if (filtersStore.deviceTypeOptions().length) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div>
                Device Type @if(filtersStore.deviceType().length) {
                  <span class="test-mobile-multiselect-device-type-inicator mobile-multiselect-filter-inicator">+{{
                    filtersStore.deviceType().length }}</span>
                  }
              </div>
              @if(filtersStore.deviceType().length) {
                <button
                  class="test-mobile-device-type-clear-btn mobile-filter-clear-btn"
                  (click)="$event.stopPropagation(); filtersStore.patchFilters({ deviceType: [] })"
                >
                  Clear
                </button>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="test-device-type-filter">
            @for (deviceType of filtersStore.deviceTypeOptions() | sort : 'asc' : 'title'; track deviceType.value) {
              <li>
                <mat-checkbox
                  class="full-width-checkbox"
                  (change)="
                    filtersStore.onCheckboxChange({
                      value: $event.source.value,
                      checked: $event.checked,
                      field: 'deviceType'
                    })
                  "
                  [checked]="filtersStore.deviceType().includes(deviceType.value)"
                  [class]="'test-device-type-option-' + deviceType.value"
                  [value]="deviceType.value"
                >
                  {{ deviceType.title }}
                </mat-checkbox>
              </li>
            }
          </ul>
        </mat-expansion-panel>
        } @if (filtersStore.deviceMakerOptions().length) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div>
                  Manufacturer @if (filtersStore.deviceMaker().length) {
                    <span class="test-mobile-multiselect-manufacturer-inicator mobile-multiselect-filter-inicator">+{{
                      filtersStore.deviceMaker().length }}</span>
                    }
                </div>
                @if (filtersStore.deviceMaker().length) {
                  <button
                    class="test-mobile-manufacturer-clear-btn mobile-filter-clear-btn"
                    (click)="$event.stopPropagation(); filtersStore.patchFilters({ deviceMaker: [] })"
                  >
                    Clear
                  </button>
                }
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="test-manufacturer-filter">
              @for (deviceMaker of filtersStore.deviceMakerOptions() | sort : 'asc' : 'title'; track deviceMaker.value) {
                <li>
                  <mat-checkbox
                    class="full-width-checkbox"
                    (change)="
                      filtersStore.onCheckboxChange({
                        value: $event.source.value,
                        checked: $event.checked,
                        field: 'deviceMaker'
                      })
                    "
                    [checked]="filtersStore.deviceMaker().includes(deviceMaker.value)"
                    [class]="'test-manufacturer-option-' + deviceMaker.value"
                    [value]="deviceMaker.value"
                  >
                    {{ deviceMaker.title }}
                  </mat-checkbox>
                </li>
              }
            </ul>
          </mat-expansion-panel>
          } @if (data.showLocationFilter) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div class="mobile-single-select-title">
                    Building @if(selectedLocationName()) {:
                      <span class="test-building-selected-value font-normal">{{ selectedLocationName() }}</span>
                    }
                  </div>
                  @if (filtersStore.building()) {
                    <button
                      class="test-building-filter-clear-btn mobile-filter-clear-btn"
                      (click)="$event.stopPropagation(); filtersStore.patchFilters({ building: '', floor: '', room: '' })"
                    >
                      Clear
                    </button>
                  }
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul class="test-building-select mobile-single-filter-select">
                @for (location of filtersStore.locationOptions() | sort : 'asc' : 'title' : 'all'; track location.value) {
                  <li
                    (click)="filtersStore.patchFilters({ building: location.value })"
                    [class.checked]="location.value === filtersStore.building()"
                    [class]="'test-building-option-' + (location.value || 'all')"
                  >
                    <span>{{ location.title }}</span>
                    <i class="icon-check text-ui-green-light text-3xl"></i>
                  </li>
                }
              </ul>
            </mat-expansion-panel>
            <mat-expansion-panel
              class="test-floor-panel"
              [disabled]="!filtersStore.building()"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div class="mobile-single-select-title">
                    Floor @if(filtersStore.floor()) {:
                      <span class="test-floor-selected-value font-normal">{{ selectedFloorName() }}</span>
                    }
                  </div>
                  @if (filtersStore.floor()) {
                    <button
                      class="test-floor-filter-clear-btn mobile-filter-clear-btn"
                      (click)="$event.stopPropagation(); filtersStore.patchFilters({ floor: '', room: '' })"
                    >
                      Clear
                    </button>
                  }
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul class="test-floor-select mobile-single-filter-select">
                @for (floor of filtersStore.floorOptions() | sort : 'asc' : 'title' : 'all'; track floor.value) {
                  <li
                    (click)="filtersStore.patchFilters({ floor: floor.value })"
                    [class.checked]="floor.value === filtersStore.floor()"
                    [class]="'test-floor-option-' + (floor.value || 'all')"
                  >
                    <span>{{ floor.title }}</span>
                    <i class="icon-check text-ui-green-light text-3xl"></i>
                  </li>
                }
              </ul>
            </mat-expansion-panel>
            <mat-expansion-panel
              class="test-room-panel"
              [disabled]="!filtersStore.floor()"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div class="mobile-single-select-title">
                    Room @if(filtersStore.room()) {:
                      <span class="test-room-selected-value font-normal">{{ selectedRoomName() }}</span>
                    }
                  </div>
                  @if (filtersStore.room()) {
                    <button
                      class="test-room-filter-clear-btn mobile-filter-clear-btn"
                      (click)="$event.stopPropagation(); filtersStore.patchFilters({ room: '' })"
                    >
                      Clear
                    </button>
                  }
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul class="test-room-select mobile-single-filter-select">
                @for (room of filtersStore.roomOptions() | sort : 'asc' : 'title' : 'all'; track room.value) {
                  <li
                    (click)="filtersStore.patchFilters({ room: room.value })"
                    [class.checked]="room.value === filtersStore.room()"
                    [class]="'test-room-option-' + (room.value || 'all')"
                  >
                    <span>{{ room.title }}</span>
                    <i class="icon-check text-ui-green-light text-3xl"></i>
                  </li>
                }
              </ul>
            </mat-expansion-panel>
          }
    </mat-accordion>
  </div>
</div>
